import React from 'react';
import 'rc-dialog/assets/bootstrap.css';

class EtiquetaEstado extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {

    }

    render() {
        let estadosEntrada = [];
        let estadosSalidas = [];
        let estados = this.props.data.estados;
        let estado = this.props.record;

        //Busco los estados de salida...
        for (var i = 0; i < estado.EstadosSalida.length; i++) {
            if (estado.EstadosSalida[i].estadoNumero !== undefined)
                estadosSalidas.push(<div className={"circuito-estado-etiqueta-div-salida circuito-etiqueta-color" + (estado.EstadosSalida[i].estadoNumero - 1)}><p>{estado.EstadosSalida[i].estadoNombre + ' [' + estado.EstadosSalida[i].estadoNumero + ']'}</p></div>);
        }

        //Busco los estados de entrada...
        for (var i = 0; i < estados.length; i++) {
            let estadoEntrada = estados[i].EstadosSalida.find(x => x.estadoId == estado.EstadoInfo.Id)
            if (estadoEntrada !== undefined) {
                estadosEntrada.push(<div className={"circuito-estado-etiqueta-div-entrada circuito-etiqueta-color" + (estados[i].EstadoNumero - 1)}><p>{'[' + estados[i].EstadoNumero + '] ' + estados[i].EstadoInfo.Descripcion}</p></div>);
            }
        }

        return (
            <div>
                {estadosEntrada}
                {estadosSalidas}
            </div>
        );
    }
}

export default EtiquetaEstado;
